/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_About_P2Inputs */

const en_pc_dl_about_p2 = /** @type {(inputs: Pc_Dl_About_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sure which file to choose? Most Windows PCs need the x64 installer, every Mac uses the universal .dmg, and on Linux the AppImage runs on almost any distribution. If you only want to try PdfCraft before installing, use the online version instead.`)
};

const zh_pc_dl_about_p2 = /** @type {(inputs: Pc_Dl_About_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不知道选哪个？大多数 Windows 电脑选 x64 安装包，所有 Mac 都用通用版 .dmg，Linux 上的 AppImage 几乎适用于任何发行版。如果只想先试试，可以直接使用在线版。`)
};

/**
* | output |
* | --- |
* | "Not sure which file to choose? Most Windows PCs need the x64 installer, every Mac uses the universal .dmg, and on Linux the AppImage runs on almost any distr..." |
*
* @param {Pc_Dl_About_P2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_about_p2 = /** @type {((inputs?: Pc_Dl_About_P2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_About_P2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_about_p2(inputs)
	return zh_pc_dl_about_p2(inputs)
});
export { pc_dl_about_p2 as "pc.dl.about_p2" }